import {
    couponScopeConst,
    couponTypeConst,
    discountCoupon,
    fullDiscountCoupon,
    platformCoupon,
    shopCoupon,
    straightReducedCoupon
} from 'config/coupon';
import { ICouponBase } from 'types/coupon';

export const getCouponType = (coupon: ICouponBase) => {
    const type = Number(coupon.type);

    if (straightReducedCoupon.indexOf(type) > -1) {
        return couponTypeConst.straightReduced;
    }
    if (fullDiscountCoupon.indexOf(type) > -1) {
        return couponTypeConst.fullDiscount;
    }
    if (discountCoupon.indexOf(type) > -1) {
        return couponTypeConst.discount;
    }
};

export const getCouponScope = (coupon: ICouponBase) => {
    const type = Number(coupon.type);

    if (platformCoupon.indexOf(type) > -1) {
        return couponScopeConst.platform;
    }

    if (shopCoupon.indexOf(type) > -1) {
        return couponScopeConst.shop;
    }
};
